<template>
  <b-card no-body>
    <b-card-body>
      <price-package-detail
        ref="pricePackageDetail"
        type="new"
        :submitting="submitting"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import PricePackageDetail from '@/views/pages/price-packages/PricePackageDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    BCard,
    BCardBody,
    PricePackageDetail
  },

  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createPricePackage(data)
        .then(response => {
          this.$refs.pricePackageDetail.resetForm();
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'price_packages' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
